import { useState } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import {
  Alert,
  Button,
  Dialog,
  VStack,
  Icon,
  Typography,
} from '@vivaahealth/design-system';

import * as api from '../../../../../api';

interface AddPhotoIdPageProps extends WithTranslation {
  isRequired: boolean;
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
  practicePreference: api.Previsit.PracticePreference;
  setFormField: (formFieldId: string, value: string) => void;
  navigateToNextPage: () => Promise<void>;
  onAddNewCard: () => Promise<void>;
}

const AddPhotoIdPage = ({
  isRequired,
  field,
  practicePreference,
  setFormField,
  navigateToNextPage,
  onAddNewCard,
  t,
}: AddPhotoIdPageProps) => {
  const [addAtAppointment, setAddAtAppointment] = useState(false);
  const handleAddAtAppointment = async () => {
    const newFormFieldValue = JSON.stringify({ didNotHaveCard: true });
    setFormField(field.id, newFormFieldValue);
    await api.client.Previsit.updateFormField(
      field.previsitFormSetId,
      field.id,
      newFormFieldValue,
    );
    await navigateToNextPage();
  };

  return (
    <VStack>
      <VStack gap={8} marginBottom={24}>
        <Typography variant="headline-small" bold>
          {t('title')}
        </Typography>
        {practicePreference.digitalArrivalNotificationSendTimeOffset && (
          <Typography variant="title-large">
            {t('digitalArrivalNote', { ns: 'photoId' })}
          </Typography>
        )}
      </VStack>
      <Alert variant="info">{t('dataIsSecure')}</Alert>
      <VStack gap={16} marginTop={32}>
        <Button fullWidth onClick={onAddNewCard}>
          {t('addNewCard', { ns: 'uploadCard' })}
        </Button>
        {!isRequired && (
          <Button
            fullWidth
            variant="outlined"
            onClick={() => setAddAtAppointment(true)}
          >
            {t('addAtAppointment', { ns: 'uploadCard' })}
          </Button>
        )}
      </VStack>
      <Dialog
        Icon={<Icon.AlertTriangle color={'#FFAE00'} size={'large'} />}
        open={addAtAppointment}
        title={t('skipIdTitle', { ns: 'photoId' })}
        description={t('skipIdWarning', { ns: 'photoId' })}
      >
        <Button fullWidth size="medium" onClick={handleAddAtAppointment}>
          {t('dontAddId', { ns: 'photoId' })}
        </Button>
        <Button
          fullWidth
          size="medium"
          variant="outlined"
          onClick={() => setAddAtAppointment(false)}
        >
          {t('nevermind')}
        </Button>
      </Dialog>
    </VStack>
  );
};

export default withTranslation(['photoId', 'uploadCard'])(AddPhotoIdPage);
